var React = require('react');

function IconDUp (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF"},React.createElement("path",{"d":"M1 11L8 4L15 11z"})));
}

IconDUp.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = IconDUp;

IconDUp.default = IconDUp;
